import type { GetUserQuery } from "@frontend/roz-sdk-core";

type UserMenuUser = NonNullable<GetUserQuery["me"]>;

export const getAvatar = (user: UserMenuUser) => {
  if (user?.avatar?.startsWith("user")) {
    return user?.avatarUrl;
  }

  return user?.avatar;
};
